import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';
import { InfoComponent } from '../list/InfoComponent';
import { useLandscapeItems } from '../list/MobileVehicleCard/useInfoItems';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Title = styled.div`
  font-size: 18px;
  color: #000;
  font-weight: 700;
`;

type Props = {
  vehicle: Vehicle;
};

export type InfoItem = {
  label: string;
  value: string;
  color?: string;
  highlighted?: boolean;
};

export const MainVehicleInfo = ({ vehicle }: Props) => {
  const [items] = useLandscapeItems(vehicle);

  return (
    <Wrapper>
      <Title>
        {vehicle.year} {vehicle.make} {vehicle.model}
      </Title>
      <InfoComponent size="lg" withBorder items={items} />
    </Wrapper>
  );
};
